import { render, staticRenderFns } from "./ApiPage.vue?vue&type=template&id=2acd11ce&scoped=true"
import script from "./ApiPage.vue?vue&type=script&lang=js"
export * from "./ApiPage.vue?vue&type=script&lang=js"
import style0 from "./ApiPage.vue?vue&type=style&index=0&id=2acd11ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd11ce",
  null
  
)

export default component.exports